import { FileText } from "lucide-react";
import { Link } from "react-router-dom";

function CreateResumeOptions() {
	return (
		<section className="bg-white py-8 md:py-12">
			<div className="mx-auto max-w-5xl px-4">
				<div className="mb-10">
					<h2 className="text-2xl font-bold text-gray-900 md:text-3xl">How do you want to build your resume?</h2>
				</div>
				<div className="flex justify-center">
					<Link
						to="/resume/select-template"
						className="block w-full max-w-md rounded-xl border border-gray-200 bg-white p-8 text-center shadow-sm transition-colors hover:border-primary-500 hover:ring-2 hover:ring-primary-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 lg:p-12"
					>
						<FileText className="mx-auto mb-6 h-10 w-10 text-primary-600" />
						<span className="mb-2 block text-lg font-bold uppercase text-gray-900">Create a new Resume</span>
						<span className="block text-gray-600">
							We will help you create a resume
							<br /> step-by-step.
						</span>
					</Link>
				</div>
			</div>
		</section>
	);
}

export default CreateResumeOptions;
